<template>
  <b-modal
    title="Configurar firmas"
    ref="config-signs"
    no-close-on-backdrop
    size="xl"
    cancel-title="Cancelar"
    ok-title="¡Listo!"
    @cancel="cancelModal"
    id="config-signs"
  >
    <div class="row">
      <div class="col-12">
        <StepSignaturePositionTemplate
          :file="file"
          :steps="steps"
          :signaturesDropped="signatures"
          @sign-position="getSignPosition"
        />
      </div>
    </div>
  </b-modal>
</template>
<script>
import StepSignaturePositionTemplate
from '@/febos/chile/approvals/wizardFlow/wizard/flow/StepSignaturePositionTemplate';

export default {
  components: { StepSignaturePositionTemplate },
  data() {
    return {
      signaturesOriginal: {}
    };
  },
  props: [
    'step',
    'steps',
    'file',
    'signatures'
  ],
  computed: {

  },
  methods: {
    getSignPosition(sign) {
      this.$emit('update-sign-position', sign);
    },
    cancelModal() {
      this.$emit('cancel-action', this.signaturesOriginal);
    }
  },
  created() {
    this.signaturesOriginal = { ...this.signatures };
  }
};
</script>
